// React
import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';

// Containers Injection
import { ServicesInjection } from '../../containers/servicesInjection';

// View
import { ServicesListPage } from './view';

export const ServicesList = () => {
  const { getServices, deleteServices, services, success } =
    ServicesInjection();

  const history = useHistory();

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Nome</span>,
      sortable: false,
      width: '30%',
      selector: (cell) => {
        return (
          <React.Fragment>
            <div className="d-flex align-items-center fw-medium ">
              <Link to={`/servicos/edit/${cell.id}`} className="currency_name">
                {cell.name}
              </Link>
            </div>
          </React.Fragment>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Valor</span>,
      selector: (row) => row.price,
      sortable: true,
    },
  ];

  const handleDelete = (id) => {
    deleteServices(id);
  };

  const handleEdit = (values) => {
    const { id } = values;
    history.push(`/servicos/edit/${id}`);
  };

  useEffect(() => {
    getServices();
  }, [success]);

  return (
    <ServicesListPage
      columns={columns}
      history={history}
      services={services}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
    />
  );
};
